import classnames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { listerClickThrough } from '../../actions/lister-actions';
import TRANSLATIONS from '../../translations/translations@default.json';

const BackInStockButton = ({
	FullProductUrl,
	Code,
	classes,
	addExclamationMark,
}) => {
	const { BackInStockButtonAndFormEnabled } = useSelector(
		(state) => state.featureSwitches
	);

	const dispatch = useDispatch();

	if (!BackInStockButtonAndFormEnabled) {
		return null;
	}

	if (FullProductUrl) {
		return (
			<a
				href={`${FullProductUrl}?letMeKnow=true`}
				onClick={(event) => {
					event.preventDefault();
					window.location.assign(`${FullProductUrl}?letMeKnow=true`);

					dispatch(listerClickThrough(Code));
				}}
				className={classnames(
					classes,
					'back-in-stock-button cta cta-secondary btn btn-secondary flex items-center justify-between leading-none w-full'
				)}
				itemProp="url">
				<div className="w-full">
					{TRANSLATIONS.productList.productCard.backInStockForm.tab}

					{TRANSLATIONS.productList.productCard.backInStockForm.phoneNumber
						.length > 0 && (
						<span className="back-in-stock-number">
							{TRANSLATIONS.productList.productCard.backInStockForm.phoneNumber}
							{addExclamationMark && '!'}
						</span>
					)}
				</div>

				<i className="ico ico-chevron-right text-lg" />
			</a>
		);
	}

	return null;
};

export default BackInStockButton;
